import { Button, ButtonProps, CircularProgress } from "@material-ui/core";
import { useForceResetPassword } from "../../../graphql/hooks/useForceResetPassword";
import { User } from "../../../graphql/models";
import { useSnackbarMessage } from "../../../hooks";

export type ForceResetUserPasswordButtonProps = {
  user: Pick<User, "id" | "firstName">;
} & Omit<ButtonProps, "disabled" | "onClick">;

export function ForceResetUserPasswordButton(
  props: ForceResetUserPasswordButtonProps
) {
  const { user, children, variant, ...btnProps } = props;
  const { raiseSuccessSnackbar } = useSnackbarMessage();
  const { loading, error, forceResetPassword } = useForceResetPassword({
    onSuccess() {
      raiseSuccessSnackbar("Password forzata");
    },
  });

  return (
    <>
      <Button
        {...btnProps}
        variant={variant ?? "contained"}
        disabled={loading}
        onClick={() => forceResetPassword(user.id)}
      >
        {loading ? (
          <CircularProgress />
        ) : (
          <>{children ?? "Forza Procedura di Reset Password"}</>
        )}
      </Button>
      {error && <span>{error.message}</span>}
    </>
  );
}
